import React from "react";

import classes from "./Post.css";
import LetterIcon from "../../UI/LetterIcon/LetterIcon";

const colors = [
  "#1abc9c",
  "#16a085",
  "#f1c40f",
  "#f39c12",
  "#8e44ad",
  "#c0392b"
];
const getRandomColor = () => {
  return colors[Math.floor(Math.random() * colors.length)];
};
const Post = props => {
  return (
    <div className={classes.Post}>
      <div className={classes.Header}>
        <LetterIcon
          letter={props.user.slice(0, 1).toUpperCase()}
          color={getRandomColor()}
          clicked={() => props.showUser(props.userID)}
        />
        <span>{props.user}</span>
      </div>
      <div className={classes.Content}>
        <div className={classes.PostTitle}>{props.title}</div>
        <div className={classes.PostContent}>{props.content}</div>
      </div>
    </div>
  );
};

export default Post;
